var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { call, put, takeLatest } from "redux-saga/effects";
import { UPLOAD_BRAND_IMAGE_REQUEST, uploadBrandImageSuccess, uploadBrandImageFailure } from "../../actions";
import API from "../../../utils/API";
const uploadBrandImage = (action) => __awaiter(void 0, void 0, void 0, function* () {
    return yield new Promise((resolve, reject) => __awaiter(void 0, void 0, void 0, function* () {
        const formData = new FormData();
        formData.append("file", action.payload);
        const countryCode = "in";
        try {
            API.formUpload(`/notification/settings/image/${countryCode}`, { file: action.payload })
                .then((response) => {
                resolve(response);
            })
                .catch((error) => {
                reject(error);
            });
        }
        catch (error) {
            reject(error);
        }
    }));
});
function* uploadBrandImageWorker(action) {
    try {
        const response = yield call(uploadBrandImage, action);
        yield put(uploadBrandImageSuccess(response));
    }
    catch (error) {
        if (error.response && error.response.data && error.response.data.message) {
            yield put(uploadBrandImageFailure(error.response.data.message));
        }
        else {
            yield put(uploadBrandImageFailure("An error occurred while uploading the file"));
        }
    }
}
export function* watchUploadBrandImage() {
    yield takeLatest(UPLOAD_BRAND_IMAGE_REQUEST, uploadBrandImageWorker);
}
